import { makeStyles } from '@fluentui/react';
export const useStyles = makeStyles((theme) => ({
  iconButtonStyles: {
    color: theme.palette.neutralPrimaryAlt,
    selectors: {
      ':hover': {
        color: theme.palette.neutralPrimaryAlt,
        borderRadius: 2,
        backgroundColor: theme.palette.neutralLight,
      },
    },
  },
  iconButtonPrimaryStyles: {
    color: 'white',
    borderRadius: 5,
    backgroundColor: 'blue',
  },
}));
